import { Controller } from "stimulus";
import sweet_alert from '../../entrypoints/src/admin/utilities/sweet_alert';

export default class extends Controller {
  static targets = ['schedulerPicker', 'btnDoSchedule'];

  connect() {
    this.schedulerPickerTarget.addEventListener('pick-schedule:save', (() => {
      this.toggleDisable(this.btnDoScheduleTarget, !this.pickScheduleCtrl.valid);
    }).bind(this));
    this.toggleDisable(this.btnDoScheduleTarget, true);
    this.btnDoScheduleTarget.addEventListener('click', this.doSchedule.bind(this));
  }

  doSchedule(ev) {
    ev.preventDefault();
    ev.stopPropagation();

    if (!this.pickScheduleCtrl.valid)
      return sweet_alert.fire({ text: 'Selecione pelo menos um horário antes de continuar!' });

    this.toggleDisable(this.btnDoScheduleTarget, true);
    this.element.submit();
  }

  toggleDisable($el, toggle) {
    toggle = typeof toggle !== 'undefined' ? toggle : $el.classList.contains('disabled');
    $el.classList.toggle('disable', toggle);

    if (toggle)
      return $el.setAttribute('disabled', 'disabled');

    $el.removeAttribute('disabled');
  }

  get pickScheduleCtrl() {
    return this.schedulerPickerTarget['components--pick-schedule'];
  }
}